import { navigate } from "gatsby-link"
import { linkResolver } from "../../prismic.config"

export default function redirect(document) {
  if (document) {
    return navigate(linkResolver(document))
  }
}
